@keyframes loader-pulse {
	0%,
	100% {
		opacity: 0.4;
		transform: scale(0.75);
	}

	50% {
		opacity: 1;
		transform: scale(1);
	}
}

.loader {
	--loader-duration: 0.8s;

	& circle {
		opacity: 0.4;
		transform: scale(0.75);
	}

	& circle:nth-child(1) {
		transform-origin: 3px 8px;
	}

	& circle:nth-child(2) {
		transform-origin: 8px 8px;
	}

	& circle:nth-child(3) {
		transform-origin: 13px 8px;
	}

	@media (prefers-reduced-motion: no-preference) {
		& circle {
			animation: loader-pulse var(--loader-duration) infinite;
		}

		& circle:nth-child(1) {
			animation-delay: calc(var(--loader-duration) / -2.666);
		}

		& circle:nth-child(2) {
			animation-delay: calc(var(--loader-duration) / -5.333);
		}
	}
}
